module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (6).4ab4fd93.jpg";